/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum VesselDisposition {
  PORTSIDE = 'Portside',
  STARBOARD = 'Starboard',
}
